
export class CC3APIModel {
  PublisherList: string = "";
  CC3ArticleSummary: string = "";
  CC3ListAPI: string = "";
  ArticleTypeListAPI: string = "";
  GetCC3DashboardCount: string = "";
  GetJournalArticleId: string = "";
  cc3FileStatusUpdate: string = "";
  GetJournalsdetails: string = "";
  GetArticleDetails: string = "";
  CC3ReportListAPI: string = "";
  ArticleTitleAPI: string = "";
  CC3ReportAPI: string = "";
  cc3SummaryLogic: string = "";
  CC3ConfigList: string = "";
  CC3ConfigCategoryList: string = "";
  DeleteCC3Article: string = "";
}
